import { router, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

export function StepShell({
  title,
  subtitle,
  children,
  onNext,
  nextLabel = "Continue",
  nextDisabled = false,
  processing = false,
}) {
  // The server resolves the neighbouring steps (Planning::IntakeWizard#state).
  const prevStep = usePage().props.wizard.prev

  const goPrev = () => {
    if (prevStep) {
      router.get(`/app/plan/intake?step=${prevStep}`, {}, { preserveState: false })
    }
  }

  return (
    <Card>
      <CardContent className="p-6 sm:p-8 space-y-6">
        <header>
          <h2 className="font-display text-2xl sm:text-3xl text-zinc-900">
            {title}
          </h2>
          {subtitle && (
            <p className="text-zinc-600 mt-2 text-sm sm:text-base">{subtitle}</p>
          )}
        </header>

        <div>{children}</div>

        <footer className="flex items-center justify-between pt-4 border-t border-zinc-100">
          <Button
            variant="ghost"
            onClick={goPrev}
            disabled={!prevStep || processing}
          >
            Back
          </Button>
          <Button
            variant="gradient"
            size="lg"
            onClick={onNext}
            disabled={nextDisabled || processing}
          >
            {processing ? "Saving…" : nextLabel}
          </Button>
        </footer>
      </CardContent>
    </Card>
  )
}
